import React, { useState } from "react";

export default function MessageInput({ onSend }) {
  const [text, setText] = useState("");
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [draftText, setDraftText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = text.trim();
    if (!message) return;
    onSend(message);
    setHistory(prev => [...prev, message]);
    setHistoryIndex(-1);
    setDraftText("");
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp") {
      if (!history.length) return;
      e.preventDefault();
      if (historyIndex === -1) {
        setDraftText(text);
        setHistoryIndex(history.length - 1);
        setText(history[history.length - 1]);
        return;
      }

      if (historyIndex > 0) {
        const nextIndex = historyIndex - 1;
        setHistoryIndex(nextIndex);
        setText(history[nextIndex]);
      }
    }

    if (e.key === "ArrowDown") {
      if (!history.length || historyIndex === -1) return;
      e.preventDefault();
      if (historyIndex < history.length - 1) {
        const nextIndex = historyIndex + 1;
        setHistoryIndex(nextIndex);
        setText(history[nextIndex]);
      } else {
        setHistoryIndex(-1);
        setText(draftText);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        value={text}
        onChange={e => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Írj üzenetet..."
      />
      <button type="submit">Küldés</button>
    </form>
  );
}